module.exports = __webpack_public_path__ + "media/components/weather-icon/static/daysomeclear-3728ac5507fc5e77ec3b9c51e57a5811.svg";